//External
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter, useRouter } from "next/router"; //Access routing
//Internal
import { Link } from "../../routes"; //Access routing
import SearchBar from "../../components/search-bar";
import {
  getSelectLocationsOptions,
  get_cookie,
  locationOptions,
  set_cookie,
} from "../../utils";
import { strToLowerCase } from "../../utils";
import {
  setShowDocumentHideProfile,
  setShowEditProfileHideShowProfile,
} from "../../store/actions";
import UserAvatar from "../common/UserAvatar";
import { ChatbotAskButton } from "../chatbot";
import homeIconUrl from "../../public/assets/images/mobile-ic/home-ic.svg";
import homeIconUrlActive from "../../public/assets/images/mobile-ic/home-blue-ic.svg";
import searchIconUrl from "../../public/assets/images/mobile-ic/search-ic.svg";
import searchIconUrlActive from "../../public/assets/images/mobile-ic/search-blue-ic.svg";
import tripIconUrl from "../../public/assets/images/mobile-ic/trip-ic.svg";
import tripIconUrlActive from "../../public/assets/images/mobile-ic/trip-blue-ic.svg";
import profileIconUrl from "../../public/assets/images/mobile-ic/profile-ic.svg";
import profileIconUrlActive from "../../public/assets/images/mobile-ic/profile-blue-ic.svg";

/*******************
  @Purpose : used for footer
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
function FooterNav({ currentLocationId, locations, userInfo, currentPage }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const asPath = router.asPath;
  const [showMenu, setShowMenu] = useState(false);

  const { slug } = router.query;
  let slug1 = "ca";
  let slug2 = "los-angeles";
  let slug3 = "rolls-royce";

  if (slug) {
    slug1 = strToLowerCase(slug[0]);
    if (slug[1]) {
      slug2 = strToLowerCase(slug[1]);
    }
    if (slug[2]) {
      slug3 = strToLowerCase(slug[2]);
    }
  }

  /*******************
  @Purpose : React Hook used for set show menu
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
  useEffect(() => {
    setShowMenu(false);
    // remove_cookie("swp");
  }, [slug]);

  /*******************
  @Purpose : React Hook used for set show menu
  @Parameter : {currentLocationId,locations,userInfo,}
  @Author : INIC
  *******************/
  useEffect(() => {
    let tempOptions = locationOptions();
    let tempDefaultOptionValue = "0";
    if (locations && locations.length !== 0) {
      tempOptions = [];
      const selectOptionsObj = getSelectLocationsOptions(
        locations,
        currentLocationId,
        "footer",
      );
      tempDefaultOptionValue = selectOptionsObj.defaultOptionValue;
      tempOptions = selectOptionsObj.options;
    }
  }, [locations]);

  /*******************
  @purpose : on location change event
  @Parameter : {slugname}
  @Author : INIC
  ******************/
  const onLocationChange = (slugName) => {
    let path = "";
    if (slugName == "/") {
      path = "/";
    } else {
      path = "/" + slugName;
    }
    set_cookie("redirectUrl", path, 1);
    router.push(path);
  };

  /*******************
  @Purpose : used for home Click redirect
  @Parameter : {}
  @Author : INIC
  *******************/
  const homeClickRedirect = () => {
    const r = get_cookie("redirectUrl");
    if (r) {
      router.push(r);
    } else {
      router.push("/");
    }
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="footer-search-bar">
        {showMenu && (
          <SearchBar
            slug1={slug1}
            slug2={slug2}
            currentLocationId={currentLocationId}
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            showAutofocus={true}
          />
        )}
      </div>

      <div className="footer-nav safe-area-bottom">
        <ul className="list-unstyled d-flex mb-0 flex-wrap footer-nav-tab">
          <li
            className={`nav-item ${
              asPath == "/" || asPath == "/fl/miami" ? "active" : ""
            }`}
          >
            <div className="nav-text ff-hel-med" onClick={homeClickRedirect}>
              <span className="icon  ic-1">
                <img src={homeIconUrl} alt="home"></img>
              </span>
              <span className="icon  ic-2">
                <img src={homeIconUrlActive} alt="home"></img>
              </span>
              Home
            </div>
          </li>
          <li
            className="nav-item"
            onClick={() => {
              setShowMenu(true);
            }}
          >
            <div className="nav-text ff-hel-med">
              <span className="icon ic-1">
                <img src={searchIconUrl} alt="search"></img>
              </span>
              <span className="icon ic-2">
                <img src={searchIconUrlActive} alt="search"></img>
              </span>
              Search
            </div>
          </li>
          <li className="nav-item">
            <ChatbotAskButton className="nav-text ff-hel-med chatbot-nav-button" />
          </li>
          <li className={`nav-item ${asPath == "/my-trips" ? "active" : ""}`}>
            <Link href="/my-trips">
              <a className="nav-text ff-hel-med">
                <span className="icon  ic-1">
                  <img src={tripIconUrl} alt="trips"></img>
                </span>
                <span className="icon  ic-2">
                  <img src={tripIconUrlActive} alt="trips"></img>
                </span>
                Trips
              </a>
            </Link>
          </li>

          <li
            className={`nav-item ${
              asPath == "/personal-details" ? "active" : ""
            }`}
            onClick={() => {
              dispatch(setShowEditProfileHideShowProfile(true));
              dispatch(setShowDocumentHideProfile(true));
            }}
          >
            {userInfo?.first_name ? (
              <Link href="/personal-details">
                <a className="nav-text ff-hel-med">
                  <span className="icon avatar-icon">
                    <UserAvatar userInfo={userInfo} />
                  </span>
                  Profile
                </a>
              </Link>
            ) : (
              <div
                className="nav-text ff-hel-med"
                onClick={() => router.push("/login")}
              >
                <span className="icon  ic-1">
                  <img src={profileIconUrl} alt="profile"></img>
                </span>
                <span className="icon  ic-2">
                  <img src={profileIconUrlActive} alt="profile"></img>
                </span>
                Log in
              </div>
            )}
          </li>
        </ul>
      </div>
    </>
  );
}

/********************
@purpose : Connect With Redux
@Parameter : {user}
@Author : INIC
******************/
const mapStateToProps = ({ user }) => ({
  userInfo: user?.userInfo,
});
export default withRouter(connect(mapStateToProps)(FooterNav));
